export default __webpack_public_path__ + "static/media/Golos Text_Black.1b1686ad.woff";